import axios from '../../axios';

export default {
  namespaced: true,
  state: { },
  getters: { },
  mutations: { },
  actions: {
    fetchClientManager({ commit, dispatch, getters }, id) {
      return new Promise((resolve, reject) => {
        // Cache-bust: this GET is otherwise served from the browser HTTP cache on
        // SPA navigation (and survives sign-out/in), so a freshly-set Villa Specialist
        // workPhone would not appear until a hard refresh. A unique URL forces a fresh fetch.
        const cacheBust = `_=${Date.now()}`;
        axios.get(`/core/users/${id}?${cacheBust}`, {
        }).then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
      });
    },
  },
};
